const swiperFeaturedProduct = new Swiper('.featured-product__contents', {
  loop: true,
  slidesPerView: 1.5,
  spaceBetween: 12,
  pagination: {
    el: '.feat-prod-pagination',
    clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 3,
      spaceBetween: 40,
    }
  }
});
